import produce from 'immer'
import { assign } from 'lodash'

import { transformIngredientKeywordToInitialState } from '../../graphql/transformers'
import { COMMON_FETCH_INGREDIENT_KEYWORDS } from '../action-types'
import { INGREDIENT_KEYWORDS_INITIAL_STATE } from '../initial-states'

const ingredientSupportingKeywordsReducer = (
  state = INGREDIENT_KEYWORDS_INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case COMMON_FETCH_INGREDIENT_KEYWORDS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: [],
        }),
      )

    case COMMON_FETCH_INGREDIENT_KEYWORDS.COMPLETE:
      return produce(state, nextState => {
        const keywords = action.payload.data.ingredientKeywords

        const { synonyms, varieties, discarded, uncategorized } =
          transformIngredientKeywordToInitialState(keywords)

        return assign(nextState, {
          isLoading: false,
          error: undefined,
          data: { synonyms, varieties, discarded, uncategorized },
        })
      })

    case COMMON_FETCH_INGREDIENT_KEYWORDS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: [],
        }),
      )

    case COMMON_FETCH_INGREDIENT_KEYWORDS.CLEANUP:
      return { ...INGREDIENT_KEYWORDS_INITIAL_STATE }

    default:
      return state
  }
}

export default ingredientSupportingKeywordsReducer
